import * as go from 'gojs';
import { getImageMobileJaw } from 'unitData/Mobile/Jaw/getImageMobileJaw';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';
import type { MobileUnitBaseNodeData } from 'gojs/types';

const alignPorts = (
  mirrored: boolean,
  model: string,
  configKey: number,
  portIndex: number,
) => {
  if (model === 'UJ473' && configKey < 2) {
    switch (portIndex) {
      case 0:
        return mirrored ? new go.Spot(1 - 2 / 12, 1) : new go.Spot(2 / 12, 1);
      case 1:
        return mirrored ? new go.Spot(1 - 4 / 12, 1) : new go.Spot(4 / 12, 1);
      case 2:
        return mirrored ? new go.Spot(1 - 10 / 12, 1) : new go.Spot(10 / 12, 1);
      default:
        break;
    }
  } else {
    switch (portIndex) {
      case 0:
        return mirrored ? new go.Spot(1 - 10 / 12, 1) : new go.Spot(10 / 12, 1);
      case 1:
        return mirrored ? new go.Spot(1 - 2 / 12, 1) : new go.Spot(2 / 12, 1);
      case 2:
        return mirrored ? new go.Spot(1 - 5 / 12, 0) : new go.Spot(5 / 12, 0);
      default:
        break;
    }
  }
};

const MobileJawTemplate = makeNode(
  getImageBinding('', (node: MobileUnitBaseNodeData) =>
    getImageMobileJaw(node.configuration.configKey, node.model),
  ),
  [
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileInputPort((node) => {
      return node.mirrored
        ? new go.Spot(1 - 3 / 12, 0)
        : new go.Spot(3 / 12, 0);
    }),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileJawTemplate;
